import { Component, OnInit, Input,Output, EventEmitter, ViewChild } from '@angular/core';
import { DocumentService } from '../../services/document.service';
import { DatePipe } from '@angular/common';
import { encode_base64, encode_utf8 } from '../../../environments/environment';
import Swal from 'sweetalert2';  
import { DocumentModel } from "../../models/document.model";
import { UploadDocumentComponent } from './upload-document/upload_document.component';
declare var $: any;

@Component({
  selector: 'ngx-document',
  templateUrl: './document.component.html'
})
export class DocumentComponent implements OnInit {
  private _pet_no: number;
  private _client_no: number;

  txtDocument_Name: string = '';
	txtDocument_Type: string = '';
	txtDocument_Note: string = '';

  data:any;

  @Input() set pet_no(value: number) {
    this._pet_no = value;
  }

  get pet_no(): number {
    return this._pet_no;
  }

  @Input() set client_no(value: number) {
    this._client_no = value;
  }

  get client_no(): number {
    return this._client_no;
  }

  constructor(
    public documentService: DocumentService
  ) { }
 
  ngOnInit(): void {
    this.documentService.getDocumentsByParams(this.pet_no,this.client_no,1, this.txtDocument_Name,this.txtDocument_Type,this.txtDocument_Note)
  }

  
  reset(){
    this.txtDocument_Name='';
    this.txtDocument_Type='';
    this.txtDocument_Note='';
    this.search();
  }

  search() {
    this.documentService.getDocumentsByParams(this.pet_no,this.client_no,1, this.txtDocument_Name,this.txtDocument_Type,this.txtDocument_Note)
  }

  uploadDocument() {
    this.documentService.current_client_no=this.client_no;
    this.documentService.current_pet_no=this.pet_no;
    $('#modalUpladDocument').modal('toggle');
    
  }

  edit(item: DocumentModel) {
    this.documentService.current_client_no=this.client_no;
    this.documentService.current_pet_no=this.pet_no;
    this.documentService.current_note=item.document_note;
    this.documentService.current_document_id=item.document_id;
    this.documentService.notifyDetailsFunction();
    $('#modalUpdateDocument').modal('toggle');
  }

  delete(item: DocumentModel) {
      Swal.fire({
        title: 'Delete this document?',
        // icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'No',
        confirmButtonText: 'Yes'
      }).then((result: any) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Loading...',
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading()
            },
          })
          this.documentService.deleteDocument(item.document_id,item)
            .then(() => {
              Swal.close();
              this.search();
            });
        }
      });
    }

    viewDocument(item: DocumentModel) {
        this.documentService.getDocument(item.document_id,item.document_type);
    }

}


